const EQUAL = 'eq';
const NOT_EQUAL = 'neq';
const NOT = 'not';
const GREATER_THAN = 'gt';
const GREATER_THAN_OR_EQUAL = 'gte';
const LESS_THAN = 'lt';
const LESS_THAN_OR_EQUAL = 'lte';
const LENGTH = 'size';
const IN = 'in';
const NOT_IN = 'notIn';
const EXISTS = 'exist';
const REQUIRED = 'required';
const MATCH = 'match';
const MATCH_ANY = 'anyOf';
const ALL_MATCH = 'all';
const ALL_VALUES_MATCH = 'allValues';
const ANY_ONE_MATCH = 'any';
const TYPE = 'type';
const HAS_KEYS = 'has';
const START_WITH = 'start';
const END_WITH = 'end';
const MATCH_PATTERN = 'pattern';
const CONTAINS = 'contains';
const SAME_AS = 'same';
const IF = 'if';

export default {
    EQUAL,
    NOT_EQUAL,
    NOT,
    GREATER_THAN,
    GREATER_THAN_OR_EQUAL,
    LESS_THAN,
    LESS_THAN_OR_EQUAL,
    LENGTH,
    IN,
    NOT_IN,
    EXISTS,
    REQUIRED,
    MATCH,
    MATCH_ANY,
    ALL_MATCH,
    ALL_VALUES_MATCH,
    ANY_ONE_MATCH,
    TYPE,
    HAS_KEYS,
    START_WITH,
    END_WITH,
    MATCH_PATTERN,
    CONTAINS,
    SAME_AS,

    IF,
};
